import React from "react";
import {
  Package, FileText, HelpCircle, MessageSquare, Image as ImageIcon, Download, Quote, Inbox, Sparkles, TrendingUp,
} from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const cards = [
  { key: "leads_new", label: "New Leads", icon: Sparkles, color: "text-[#D4AF37]", link: "/admin/leads" },
  { key: "leads", label: "Total Leads", icon: TrendingUp, color: "text-emerald-400", link: "/admin/leads" },
  { key: "contacts_new", label: "New Contacts", icon: Inbox, color: "text-rose-400", link: "/admin/contacts" },
  { key: "contacts", label: "Contact Submissions", icon: MessageSquare, color: "text-amber-400", link: "/admin/contacts" },
  { key: "blog_posts", label: "Blog Posts", icon: FileText, color: "text-sky-400", link: "/admin/blog" },
  { key: "products", label: "Products", icon: Package, color: "text-emerald-400", link: "/admin/products" },
  { key: "faqs", label: "FAQs", icon: HelpCircle, color: "text-violet-400", link: "/admin/faqs" },
  { key: "testimonials", label: "Testimonials", icon: Quote, color: "text-[#D4AF37]", link: "/admin/testimonials" },
  { key: "banners", label: "Banners", icon: ImageIcon, color: "text-pink-400", link: "/admin/banners" },
  { key: "downloads", label: "Download Links", icon: Download, color: "text-cyan-400", link: "/admin/downloads" },
];

export default function AdminDashboard() {
  const [stats, setStats] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    api.get("/admin/stats").then((r) => {
      setStats(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="overline mb-3">Dashboard</div>
      <h1 className="font-[Outfit] text-3xl sm:text-4xl text-white font-light tracking-tight">Overview</h1>
      <p className="text-slate-400 text-sm mt-2">Quick snapshot of content and inbound activity.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map((c) => (
          <Link to={c.link} key={c.key} className="card-luxury p-6 group hover:border-sky-500/30" data-testid={`stat-${c.key}`}>
            <c.icon className={`w-5 h-5 ${c.color}`} />
            <div className="mt-4 font-[Outfit] text-3xl text-white font-light">
              {loading ? "—" : (stats[c.key] ?? 0)}
            </div>
            <div className="text-xs uppercase tracking-widest text-slate-400 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-10 card-luxury p-6">
        <div className="overline mb-2">Tip</div>
        <h3 className="font-[Outfit] text-2xl text-white font-light">Track every conversion in real time.</h3>
        <p className="text-slate-400 text-sm mt-2">
          See lead sources, CTA performance and daily activity in the new <Link to="/admin/analytics" className="text-sky-400 hover:text-sky-300">Analytics dashboard →</Link>
        </p>
      </div>
    </div>
  );
}
